import { gql } from '@apollo/client';
import { OrderCloseFiltersInput } from '../queries/getPendingCloseOrders';

export const GENERATE_ORDER_CLOSE_DOWNLOAD_REPORT = gql`
    mutation GenerateOrderCloseDownloadReport($filters: OrderCloseFiltersInput, $timezone: String) {
        generateOrderCloseDownloadReport(filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateOrderCloseDownloadReportVariables {
    filters?: OrderCloseFiltersInput;
    timezone?: string;
}

export interface GenerateOrderCloseDownloadReportResponse {
    generateOrderCloseDownloadReport: string;
}
